import { Link, useLocation } from "react-router-dom";
import { Heart } from "lucide-react";
import { useEffect, useState } from "react";

/**
 * Floating donate CTA — visible on every page except /donate itself.
 * Fades in after the user scrolls past the initial fold so the hero can breathe first.
 */
export default function FloatingDonate() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 240);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Don't show on the donate page itself, admin, or auth pages
  const HIDDEN = ["/donate", "/login", "/register", "/forgot-password", "/reset-password", "/verify-email"];
  if (HIDDEN.some((p) => pathname === p || pathname.startsWith("/admin"))) return null;

  return (
    <Link
      to="/donate"
      data-testid="floating-donate-btn"
      aria-label="Donate to fuel the journey"
      className={`floating-donate group fixed z-40 bottom-6 right-6 md:bottom-8 md:right-8 inline-flex items-center justify-center gap-0 md:gap-2 rounded-full bg-[var(--terracotta)] text-[var(--ink)] w-14 h-14 md:w-auto md:h-auto md:pl-5 md:pr-6 md:py-3.5 shadow-[0_18px_50px_-12px_rgba(224,122,95,0.55),0_8px_20px_-4px_rgba(0,0,0,0.35)] hover:bg-[var(--terracotta-dark)] hover:shadow-[0_22px_60px_-10px_rgba(224,122,95,0.7),0_10px_24px_-4px_rgba(0,0,0,0.4)] hover:-translate-y-0.5 transition-all duration-300 ${
        visible ? "opacity-100 translate-y-0 pointer-events-auto" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      <span className="relative flex h-5 w-5 items-center justify-center">
        <span className="absolute inline-flex h-full w-full rounded-full bg-white/40 opacity-70 animate-ping" />
        <Heart className="relative w-5 h-5 md:w-4 md:h-4 fill-white" strokeWidth={0} />
      </span>
      <span className="hidden md:inline text-sm font-medium tracking-tight">Donate</span>
    </Link>
  );
}
